<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>
    <v-autocomplete
      ref="autocomplete"
      :name="schema.model"
      :id="generateId(schema.model)"
      :rules="rules"
      :search-input.sync="searchWatch"
      :items="items"
      :item-text="schema.searchParams.text"
      :item-value="schema.searchParams.value"
      v-model="value"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      @click:clear="clear()"
      :disabled="schema.readonly"
      :cache-items="schema.attributesSelect.cacheItems ?? true"
      v-bind="schema.attributesSelect"
      v-if="schema.searchParams"
    >
      <template v-slot:label>
        {{ schema.attributesSelect.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-autocomplete>

    <v-autocomplete
      :name="schema.model"
      :id="generateId(schema.model)"
      :value="schema.value"
      :rules="rules"
      v-model="value"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      @click:clear="clear()"
      v-bind="schema.attributesSelect"
      :disabled="schema.readonly"
      v-if="!schema.searchParams"
    >
      <template v-slot:label>
        {{ schema.attributesSelect.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import pageServices from '@/services/page';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data: () => ({
    searchWatch: null,
    items: [],
    hasNotCachedSearch: false,
  }),

  async created() {
    if (('cacheItems' in this.schema?.attributesSelect && !this.schema?.attributesSelect?.cachedItems)){
      this.hasNotCachedSearch = true;
    }
    if (this.schema.attributesSelect.multiple && this.value && this.value.length) {
      if (typeof this.value === 'string') {
        this.value = JSON.parse(this.value);
      }
    }
    if (this.schema.searchParams && this.value) {
      await this.getSelectedDescription(this.value);
    }

    this.updateInitValueSelected();
  },

  updated () {
    this.updateInitValueSelected();
  },

  methods: {
    onChange: async function () {
      this.changeEvents();
    },

    clear() {
      this.$nextTick(() => {
        this.value = '';

        if (this.hasGenerateDynamic) {
          this.items = [];
          this.$refs.autocomplete.cachedItems = [];
        };
      });
    },

    async getSelectedDescription(id) {
      const { procedure } = this.schema.searchParams;
      if (id) {
        const { data } = await pageServices.lookupWindow({
          procedure: procedure,
          component: this.schema.searchParams.component,
          requestApi: this.schema.searchParams.requestApi,
          model: { id: id, ...this.model },
          page: this.formOptions.page
        });

        if (data.isValid) {
          this.items = data.values;
        }
      }
    },

    searchDebounced(val, self) {
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.search(val, self);
      }, 500); /* 500ms throttle */
    },

    async search(val, self) {
      const { procedure, component, requestApi, numberCharactersSearch, value } = self.schema.searchParams;

      if (!val) return;

      const { data } = await pageServices.lookupWindow({
        procedure,
        component,
        requestApi,
        model: { like: val, ...self.model },
        page: self.formOptions.page
      });

      if (!data.isValid) return;

      if (this.hasNotCachedSearch && (!this.searchWatch || this.searchWatch.length < numberCharactersSearch)) return;

      self.items = data.values;
    },

    updateInitValueSelected () {
      let itemsList = this.schema.attributesSelect.items;

      // Caso a model esteja vazia e o lookup tenha preenchida a lista de items no componente
        // então o valor setado como padrão (selected) deverá refletir no value do componente
      if ( itemsList && this.model[this.schema.model] == null ) {
        itemsList.forEach(item => {
          if (item.selected) {
            this.value = item.value;
          }
        })
      }
    }
  },

  watch: {
    searchWatch(newValue, oldValue) {
      const { numberCharactersSearch = 0 } = this.schema.searchParams;

      const isNewValueValid = newValue && newValue !== oldValue && newValue.length >= numberCharactersSearch;
      const isItemNotSelected = !this.$refs.autocomplete.selectedItems.some(item => item[this.schema.searchParams.text] === newValue);

      if (isNewValueValid && isItemNotSelected) {
        this.searchDebounced(newValue, this);
      }

      if (this.hasNotCachedSearch) {
        const shouldClear = (newValue && newValue.length < numberCharactersSearch) || (!newValue && oldValue) || newValue === null;
        if (shouldClear) {
          this.clear();
        }
      }
    },

    value(val) {
      if (Array.isArray(val) && val.length > this.schema.max) {
        this.$nextTick(() => this.value.pop());
      }

      if (this.schema.attributesSelect.multiple && val) {
        this.value = Array.isArray(val) ? val : JSON.parse(val);
      }

      if (
        this.schema.searchParams &&
        this.value &&
        !this.$refs.autocomplete.cachedItems.some(item => item[this.schema.searchParams.value] === val)
      ) {
          this.getSelectedDescription(this.value);
      }
    }
  }
};
</script>
